import { _s } from '@/locale';

const Heading = () => (
  <h1 className="text-secondary-500 text-h-m font-semibold md:text-4xl">{_s('blogPage.heading')}</h1>
);

export default Heading;
